import { render, staticRenderFns } from "./PurchaseReport.vue?vue&type=template&id=4456883a"
import script from "./PurchaseReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports